import React from "react";

const TeterPage = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-6 p-6 rounded-md h-full">
      <img
        src="/images/vandawelcomepic.png"
        alt="No Incomes Found"
        className="max-h-[500px]  rounded-md p-2"
      />
      <p className="font-semibold text-center"> این بخش در حال راه اندازی است و به زودی در دسترس کاربران قرار می گیرد.</p>
    </div>
  );
};

export default TeterPage;

// import React from "react";
// import CountUp from "react-countup";
// import icons from "../../lib/icons";

// const TeterPage = () => {
//   // Example constant prices
//   const buyPrice = 56000; // تومان
//   const sellPrice = 55000; // تومان

//   return (
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
//       {/* Balance Cards */}
//       <BalanceCard
//         en_key="current_usdt_balance"
//         title="موجودی تـتـری"
//         value={501895400}
//         symbol="USD₮"
//       />
//       <BalanceCard
//         en_key="current_rial_balance"
//         title="موجودی ریالی"
//         value={256.8}
//         symbol="RIAL"
//       />

//       {/* Buy Tether Card */}
//       <TradeCard
//         type="buy"
//         price={buyPrice}
//         onAction={() => alert("Buy Tether clicked")}
//       />

//       {/* Sell Tether Card */}
//       <TradeCard
//         type="sell"
//         price={sellPrice}
//         onAction={() => alert("Sell Tether clicked")}
//       />
//     </div>
//   );
// };

// export default TeterPage;

// /**
//  * Balance Card Component
//  */
// const BalanceCard = ({ title, value, symbol }) => (
//   <div className="col-span-1 bg-white py-8 flex flex-col gap-4 items-center rounded-[12px] shadow">
//     <h4 className="font-semibold text-[12px] truncate">{title}</h4>
//     <div className="text-neutral-90 font-semibold text-[16px] md:text-[24px] truncate">
//       <CountUp start={0} end={value} duration={1} separator="," />
//     </div>
//     <span className="text-sm text-gray-600">{symbol}</span>
//   </div>
// );

// /**
//  * Trade Card Component
//  */
// const TradeCard = ({ type, price, onAction }) => {
//   const isBuy = type === "buy";

//   return (
//     <div
//       className={`col-span-1 bg-white py-8 px-4 flex flex-col gap-4 items-center rounded-[12px] shadow ${
//         isBuy ? "bg-[#BBF7D0]" : " bg-[#F2C1C1]"
//       }`}
//     >
//       <h4 className="font-semibold text-[14px] text-center">
//         {isBuy ? "خرید " : "فروش "}
//       </h4>

//       <span className="text-neutral-90 font-semibold text-[16px] md:text-[24px] truncate">
//         <CountUp start={0} end={price} duration={1} separator="," /> تومان
//       </span>

//       <button
//         onClick={onAction}
//         className={`flex gap-2 items-center py-[10px] w-full px-4 rounded-md text-dark text-[22px] leading-[170%] font-semibold ${
//           isBuy ? "bg-success-10 " : "bg-error-10"
//         } transition-colors`}
//       >
//         <img src={icons.plus} alt="" className="invert" />
//         {isBuy ? " میخواهم تـتـر بخرم" : " میخواهم تـتـر بفروشم"}
//       </button>
//     </div>
//   );
// };
